import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {APIUrl} from './constants';
import {ImagesServiceUrl} from './constants';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  readonly APIUrl = APIUrl;
  readonly ImagesServiceUrl = ImagesServiceUrl;

  constructor(private http:HttpClient) { }
  
  GetInternalTaskEmailNotificationSubject(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/Internal/Task/Email/Notification/Subject', val)
  }

  SendInternalTaskEmailNotification(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Send/Internal/Task/Email/Notification', val)
  }

  DeleteInternalTask(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Delete/Internal/Task', val)
  }

  GetAllInternalTasksAssignees(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/All/Internal/Tasks/Assignees', val)
  }

  GetInternalTasksFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/Internal/Tasks/Filtered/COUNT', val)
  }

  GetInternalTasksFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/Internal/Tasks/Filtered', val)
  }

  GetAllInternalTasksCreators(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/All/Internal/Tasks/Creators', val)
  }

  SearchInternalTasks(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Search/Internal/Tasks', val)
  }

  UpdateInternalTaskStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Update/Internal/Task/Status', val)
  }

  GenerateUIMessageOnStatusChange(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Generate/UIMessage/On/Status/Change', val)
  }

  LockInternalTask(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Lock/Internal/Task', val)
  }

  AddUpdateInternalTaskComment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Add/Update/Internal/Task/Comment', val)
  }

  DeleteInternalTaskComment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Delete/Internal/Task/Comment', val)
  }

  UpdateInternalTask(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Update/Internal/Task', val)
  }

  GetInternalTask(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/Internal/Task', val)
  }

  AddInternalTask(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Add/Internal/Task', val)
  }

  GenerateInitialCommentForUI(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Generate/Initial/Comment/ForUI', val)
  }

  GenerateInitialTaskForUI(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Generate/Initial/Task/ForUI', val)
  }

  GetInternalTasksMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/InternalTasks/Get/Internal/Tasks/MasterData', val)
  }

  ExportActivityLog(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ActivityLog/Export/Activity/Log', val)
  }

  GetLogsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ActivityLog/Get/Logs/Filtered/Count', val)
  }

  GetLogsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ActivityLog/Get/Logs/Filtered', val)
  }

  InitializeNewPaymenOnNewReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Initialize/NewPaymen/On/NewReception', val)
  }

  CheckUnAllocatedPaymentsByDocumentNumber(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Check/UnAllocated/Payments/ByDocumentNumber', val)
  }

  AddGroupPayment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Add/Group/Payment', val)
  }

  GetSpendingPayments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Get/Spending/Payments', val)
  }

  GetReceptionPayments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Get/Reception/Payments', val)
  }

  UpdatePayment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Update/Payment', val)
  }

  GetPaymentsMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Get/Payments/MasterData', val)
  }

  GetPaymentsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Get/Payments/Filtered', val)
  }

  GetPaymentsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Get/Payments/Filtered/COUNT', val)
  }

  AddPayment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Add/Payment', val)
  }

  DeletePayment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Delete/Payment', val)
  }

  GetPaymentsFilteredTotalValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Payments/Get/Payments/Filtered/TotalValues', val)
  }

  AutoPrintSpendings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Auto/Print/Spendings', val)
  }

  SearchSpendings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Search/Spendings', val)
  }

  RemoveSpendingFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Remove/Spending/File', val)
  }

  CancelOrActivateSpending(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Cancel/Activate/Spending', val)
  }

  DownloadSpendingFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Download/Spending/File', val)
  }

  UploadSpendingFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Upload/Spending/File', val)
  }

  PrepareNewSpendingDataOnPartnerSelect(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Prepare/NewSpending/Info', val)
  }

  GetSpendingsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Get/Filtered/Count', val)
  }

  GetSpendingsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Get/Filtered', val)
  }

  DeleteSpending(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Delete/Spending', val)
  }

  GetSpendingsMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Get/MasterData', val)
  }

  GetSpending(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Get/Spending', val)
  }

  AddUpdateSpending(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Spendings/Add/Update/Spending', val)
  }

  AutoAllocateClientBalance(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Auto/Allocate/Client/Balance', val)
  }

  PrepareGenerateUITDataUX(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Prepare/Generate/UIT/DataUX', val)
  }

  GetUpcomingPaymentsCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Upcoming/Payments/COUNT', val)
  }

  GetUpcomingPayments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Upcoming/Payments', val)
  }

  ImplementPaystub(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Implement/Paystub', val)
  }

  GeneratePaymentDocumentEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Payment/Document/Email', val)
  }

  AllocateCashCollection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Allocate/Cash/Collection', val)
  }

  PrepareEFacturaReceptionImports(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Prepare/EFactura/Reception/Imports', val)
  }

  AllocateTransportationCostsOnDocuments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Allocate/Transportation/Costs/On/Documents', val)
  }

  UpdateDocumentTransportationCost(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Update/Document/Transportation/Cost', val)
  }

  GetEFacturaReceivedInvoicesFromDocumentsDBFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/EFactura/Received/Invoices/From/Documents/DB/Filtered', val)
  }

  ImportEFacturaFiles(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Import/EFactura/Files', val)
  }

  GetEFacturaSupplierFiles(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/EFactura/Supplier/Files', val)
  }

  GetEFacturaFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/EFactura/Supplier/File', val)
  }

  PrepareEFacturaSupplierDocumentsFiles(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Prepare/EFactura/Supplier/Documents/Files', val)
  }

  GetCreditDebitChart(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Credit/Debit/Chart', val)
  }

  SellThroughPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Sell/Through/Partner', val)
  }

  PrepareSellThroughPartnerTransferInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Prepare/Sell/Through/Partner/Transfer/Invoices', val)
  }

  ProofSellThroughPartnerStepTwo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Proof/Sell/Through/Partner/Step/Two', val)
  }

  PreparePurchasePriceCurrencyAndVATAdjustmentBetweenSubordonates(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Prepare/Purchase/Price/Currency/And/VAT/Adjustment/Between/Subordonates', val)
  }

  GetClientCCBalance(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Client/CC/Balance', val)
  }

  GetUpcomingInvoicesToBePaidCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Upcoming/Invoices/To/Be/Paid/COUNT', val)
  }

  GetUpcomingInvoicesToBePaid(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Upcoming/Invoices/To/Be/Paid', val)
  }

  GetInvoiceByAccountingDisplayValue(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoice/By/Accounting/Display/Value', val)
  }

  DeleteInvoiceBox(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Delete/Box', val)
  }

  GenerateSAGAExport(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Generate/SAGA/Export', val)
  }

  AddUpdateInvoiceModelSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Add/Update/Invoice/Model/Settings', val)
  }

  InitializeNewCashCollectionCCPage(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Initialize/New/Cash/Collection/CCPage', val)
  }

  GetGalleryInvoicesAfterInfo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Gallery/Invoices/After/Info', val)
  }

  GetInvoicesCollectionRemainingOrSuprlusValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoices/Collection/Remaining/Or/Suprlus/Values', val)
  }

  InitializeNewCashCollection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Initialize/New/CashCollection', val)
  }

  ForceInvoiceDocumentClosing(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Force/Document/Closing', val)
  }

  GetGalleryInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Gallery/Invoices', val)
  }

  GetInvoicesBasicInfo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoices/Basic/Info', val)
  }

  UpdateInvoiceObservations(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Update/Invoice/Observations', val)
  }

  GenerateInvoicesDeliveryNote(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Generate/Delivery/Note', val)
  }

  DeleteShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Delete/Shipping/Details', val)
  }

  UpdateShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Update/Shipping/Details', val)
  }

  AddShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Add/Shipping/Details', val)
  }

  ProofShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Proof/Shipping/Details', val)
  }

  GetInvoiceShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoice/ShippingDetails', val)
  }

  GetInvoicePurchasePrices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoice/Purchase/Prices', val)
  }

  ConvertAdvancePaymentInvoiceToFinancialInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Convert/Advance/Payment/Invoice/To/Financial/Invoice', val)
  }

  ImplementAdvancePaymentValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Implement/Advance/Payment/Values', val)
  }

  GetAdvancePaymentTotal(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Advance/Payment/Total', val)
  }

  ConvertProformaToInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Convert/Proforma/To/Invoice', val)
  }

  AddGroupCashCollection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Add/Group/CashCollection', val)
  }

  ExportCashCollectionsValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Export/CashCollections/Values', val)
  }

  SearchInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Search/Invoices', val)
  }

  UpdateCashCollection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Update/CashCollection', val)
  }

  GetCashCollectionsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/CashCollections/Filtered/Count', val)
  }

  DeleteCashCollection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Delete/CashCollection', val)
  }

  GetCashCollectionsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/CashCollections/Filtered', val)
  }

  ExportInvoicesValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Export/Invoices/Values', val)
  }

  AdjustPaymentTermOnPartnerSelect(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Adjust/PaymentTerm/OnPartnerSelect', val)
  }

  SearchProductsInvoicingInformation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Search/Products/InvoicingInformation', val)
  }

  AddCashCollection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Add/Cash/Collection', val)
  }

  AutoPrintInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Auto/Print/Invoices', val)
  }

  CancelOrActivate(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Cancel/Activate/Invoice', val)
  }

  DeleteInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Delete/Invoice', val)
  }

  GetInvoicesFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Filtered/Count', val)
  }

  GetInvoicesFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Filtered', val)
  }

  ExportInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Export/Invoice', val)
  }

  UpdateInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Update/Invoice', val)
  }

  UpdateInvoiceDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Update/Invoice/Details', val)
  }

  GetInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoice', val)
  }

  AddInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Add/New/Invoice', val)
  }

  ApplyInvoiceDiscount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Apply/Document/Discount', val)
  }

  GetInvoiceTotalValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Total/Values', val)
  }

  GetInvoiceMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/MasterData', val)
  }

  GetInvoiceCashCollections(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoice/CashCollections', val)
  }

  GetCashCollectionsFilteredTotalValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Invoicing/Get/Invoice/CashCollections/Total/Values', val)
  }

  MergeInvoices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Merge/Invoices', val)
  }

  GenerateManagementEmailSubject(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Management/Email/Subject', val)
  }

  RecallibrateProfitsSTP(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Recallibrate/Profits/STP', val)
  }

  GetSalesDocumentsTraces(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Sales/Documents/Traces', val)
  }

  SendOverdueInvoiceNotificationEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Send/Overdue/Invoice/Notification/Email', val)
  }

  GeneratePartnerNotificationEmailSubjectAndBody(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Partner/Notification/Email/Subject/And/Body', val)
  }

  CombinePartners(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Combine/Partners', val)
  }

  GetCompanySubordonates(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Company/Subordonates', val)
  }

  GenerateReceptionFromInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Reception/From/Invoice', val)
  }

  GetDeletingEntitiesCount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Deleting/Entities/Count', val)
  }

  GetDeletingEntities(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Deleting/Entities', val)
  }

  DeleteCompany(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Delete/Company', val)
  }

  DeteleData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Detele/Data', val)
  }

  GetDeletingDocuments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Deleting/Documents', val)
  }

  ExtractTranzactionsFromSubordonateInfo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Extract/Tranzactions/From/SubordonateInfo', val)
  }

  AddInvoiceFromAccountingAPI(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Add/Invoice', val)
  }

  AddReceptionFromAccountingAPI(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Add/Reception', val)
  }

  ExportPartnerSheet(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Export/Partner/Sheet', val)
  }

  GeneratePartnerSheet(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Partner/Sheet', val)
  }

  GetShippingCompanyTransferListCashCollections(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/ShippingCompany/TransferList/CashCollections', val)
  }

  GetTaxationReportElements(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Taxation/Report/Elements', val)
  }

  GetTaxationMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Taxation/MasterData', val)
  }

  GetTaxationReport(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Taxation/Report', val)
  }

  GetMostRecentProductInformation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/MostRecent/Product/Information', val)
  }

  GetSuppliersDebt(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Suppliers/Debt', val)
  }

  GetClientsDebt(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Clients/Debt', val)
  }

  GetCCPChart(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/CCP/Chart', val)
  }

  GetVATChart(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/VAT/Chart', val)
  }

  GetSalesCharts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Sales/Charts', val)
  }

  AddPurchaseContractWithReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Add/PurchaseContract/With/Reception', val)
  }

  GeneratePurchaseContractFromReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/PurchaseContract/From/Reception', val)
  }

  GenerateReceptionFromPurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Reception/From/PurchaseContract', val)
  }

  GenerateDocumentEmailSubject(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/Document/Email/Subject', val)
  }

  SendInvoicesNotification(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Send/Invoices/Notification', val)
  }

  SendDocumentEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Send/Document/Email', val)
  }

  ImportPayments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Import/Payments', val)
  } 

  ImportCashCollections(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Import/CashCollections', val)
  } 

  GetBankExtrasPayments(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Bank/Extras/Payments', val)
  } 

  GetBankExtrasCashCollections(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Bank/Extras/CashCollections', val)
  } 

  GetBankExtrasCashCollectionsByPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Bank/Extras/CashCollections/ByPartner', val)
  } 

  GetStockBalanceTotalValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Stock/Balance/Totals', val)
  } 

  GetStockBalanceCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Stock/Balance/Count', val)
  } 

  ExportStockBalanceValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Export/Stock/Balance', val)
  } 

  GetStockBalance(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Stock/Balance', val)
  }

  GetVATReport(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/VAT/Report', val)
  }

  GetAccountingMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/MasterData', val)
  }

  UploadETransportInvoice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Upload/ETransport/Invoice', val)
  }

  GenerateUIT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Generate/UIT', val)
  }

  UploadEFactura(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Upload/EFactura', val)
  }

  GetEFacturaXML(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/EFactura/XML', val)
  }

  GetCompanyEFacturaGeneralData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/Company/EFactura/General/Data', val)
  }

  GetEFacturaState(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/EFactura/State', val)
  }

  GetEFacturaFiles(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Get/EFactura/Files', val)
  }

  ResetEFacturaStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Reset/EFactura/Status', val)
  }

  AddUpdateCompanyUXDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Update/Company/UXDetails', val)
  }

  PrepareCompanyEFacturaAwaitingToken(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Prepare/Company/EFactura/Awaiting/Token', val)
  }

  AddUpdateCompanyEFacturaSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Update/Company/EFactura/Settings', val)
  }

  GetCompanyAgents(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/Agents', val)
  }

  DeleteCompanyNotification(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Delete/Company/Notification', val)
  }

  UnreadNotification(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Unread/Notification', val)
  }

  AddNewCompanyNotification(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/New/Company/Notification', val)
  }

  ReadCompanyNotifications(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Read/Company/Notifications', val)
  }

  GetCompanyNotificationsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/Notifications/Filtered', val)
  }

  GetCompanyNotificationsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/Notifications/Filtered/COUNT', val)
  }

  UpdateCompanyRelationshipProfitMargin(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Update/Company/Relationship/ProfitMargin', val)
  }

  GetCompanyHealthStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/Health/Status', val)
  }

  GetCompanyRelationships(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/Relationships', val)
  }

  GetCompanyNewRelationshipMasteData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/NewRelationship/MasteData', val)
  }

  AddCompany(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Company', val)
  }

  GetCompany(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/Details', val)
  }

  DeleteSMTPEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Delete/SMTPEmail', val)
  }

  GetCompanySMTPEmails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/SMTPEmails', val)
  }

  AddUpdateCompanySMTPEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Update/Company/SMTPEmail', val)
  }

  DeleteSMTPConfig(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Delete/SMTPConfig', val)
  }

  AddUpdateSMTPServerConfig(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Update/SMTP/ServerConfig', val)
  }

  GetCompanySMTPConfigs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/SMTPConfigs', val)
  }

  GetAllCompanies(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/getall', val)
  }

  RequestUserCompanyAccess(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Request/User/Access', val)
  }

  GetCompanyByID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company', val)
  }

  GetCompanyBankAccounts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Get/Company/BankAccounts', val)
  }

  UpdateCompanyData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Update/Company/Data', val)
  }

  AddUpdateAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Agent', val)
  }

  DeleteAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Delete/Agent', val)
  }

  AddCompanyAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Address', val)
  }

  DeleteCompanyAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Delete/Company/Address', val)
  }

  AddCompanyBankAccount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Company/BankAccount', val)
  }

  UpdateCompanyBankAccount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Update/Company/BankAccount', val)
  }

  DeleteCompanyBankAccount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Delete/Company/BankAccount', val)
  }

  AddUpdateCompanyLogo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Update/Company/Logo', val)
  }

  AddAgentSignature(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Agent/Signature', val)
  }

  AddCompanyRelationShip(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/Company/RelationShip', val)
  }


  AddNewCompanySeries(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/company/Add/New/Company/Series', val)
  }

  GetUserDisabledFlag(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/User/Disabled/Flag', val)
  }

  GetUserB2BSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/User/B2B/Settings', val)
  }

  GrantUserAppUrlsAccess(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Grant/User/App/Urls/Access', val)
  }

  EnableDisableUser(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Enable/Disable/User', val)
  }

  AddUpdateUserAppAccess(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Add/Update/User/AppAccess', val)
  }

  ProcessPasswordRecoveryUrlData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Process/Password/Recovery/Url/Data', val)
  }

  UpdateUserLastSelectedApplication(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Update/User/Last/Selected/Application', val)
  }

  GetUserAppAccess(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/User/AppAccess', val)
  }

  SendRecoverPasswordEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Send/Recover/Password/Email', val)
  }

  GetUserUnassignedCompanies(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/User/Unassigned/Companies', val)
  }

  AddUpdateUserManagementInfo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Add/Update/User/ManagementInfo', val)
  }

  GetUserManagementInfo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/User/Management/Info', val)
  }

  GetSetApplicationByUrl(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/Set/Application/By/Url', val)
  }

  GetUserLastUsedCompany(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Get/User/LastUsed/Company', val)
  }

  UpdateUserLastUsedCompany(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Update/User/LastUsed/Company', val)
  }

  RegisterNewUser(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/register', val)
  }

  VerifyMFAToken(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/Verify/MFA/Token', val)
  }

  Login(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/login', val)
  }

  UpdateUser(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/update/details', val)
  }
  
  ResetToken(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/token/reset', val)
  }

  ChangeUserPassword(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/change/password', val)
  }

  CheckUserRouteAccess(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/check/route/access', val)
  }

  GetURLs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/get/urls', val)
  }

  UpdateUserURLAccess(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/update/url/access', val)
  }

  GetHSCodesFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/HSCodes/Filtered', val)
  }

  DeleteHSCode(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/HSCode', val)
  }

  AddUpdateHSCode(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/HSCode', val)
  }

  AddUpdateShippingCompanyWithDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Shipping/Company/With/Details', val)
  }

  GetExpectedPOProductsPrices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Expected/POProducts/Prices', val)
  }

  DeleteHSCodeDescription(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/HSCode/Description', val)
  }

  GetHSCodeDescriptions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/HSCode/Descriptions', val)
  }

  AddUpdateHSCodeDescription(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/HSCode/Description', val)
  }

  GetShippingCompaniesFullData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Shipping/Companies/Full/Data', val)
  }

  DeleteShippingCompanySupportEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Shipping/Company/Support/Email', val)
  }
  
  AddUpdateShippingCompanySupportEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Shipping/Company/Support/Email', val)
  }

  AddUpdateShippingCompany(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Shipping/Company', val)
  }

  GetShippingCompanySupportEmailData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Shipping/Company/Support/Email/Data', val)
  }

  GetTrackingStatuses(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Tracking/Statuses', val)
  }

  GetAccountingSeriesModelSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Accounting/Series/Model/Settings', val)
  }

  GetAddressesFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Addresses/Filtered', val)
  }

  GetAutomatedTasks(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Automated/Tasks', val)
  }

  DeleteWHZone(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/WH/Zone', val)
  }

  AddUpdateWHZone(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/WH/Zone', val)
  }

  GetWHZones(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/WH/Zones', val)
  }

  GetWarehousesFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Warehouses/Filtered', val)
  }

  AddUpdateBrand(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Brand', val)
  }

  DeleteBrand(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Brand', val)
  }

  AddUpdateWarehouse(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Warehouse', val)
  }

  DeleteWarehouse(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Warehouse', val)
  }

  GetShippingMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Shipping/Master/Data', val)
  }

  GetActivityLogMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/ActivityLog/MasterData', val)
  }

  GetConnectedServicePushLog(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Connected/Service/PushLog', val)
  }

  UpdateAPISettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Update/API/Settings', val)
  }

  GetAPiSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/APi/Settings', val)
  }

  GetPrinterSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Printer/Settings', val)
  }

  AddUpdatePrinterSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Printer/Settings', val)
  }

  AutoPrintDocument(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Auto/Print/Document', val)
  }

  GetShippingCompanies(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Shipping/Companies', val)
  }

  DeleteAdministration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Administration', val)
  }

  AddAdministration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Administration', val)
  }

  GenerateDescriptionRows(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Generate/Description/Rows', val)
  }

  GetDateByPaymentTerm(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Date/ByPaymentTerm', val)
  }

  UpdateAccountingSeries(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Update/AccountingSeries', val)
  }

  AddSeriesLogo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Series/Logo', val)
  }

  DeleteAccountingSeries(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/AccountingSeries', val)
  }

  UpdateAccountingSeriesActiveFlag(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Update/AccountingSeries/ActiveFlag', val)
  }

  AddUpdateCountryVATRate(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Update/Country/VATRate', val)
  }

  AddBank(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Bank', val)
  }

  GetAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Address', val)
  }

  UpdateAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Update/Address', val)
  }

  AddAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Address', val)
  }

  GetMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/masterData', val)
  }

  GetCurrencyLiveExchange(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Live/Exchange', val)
  }

  ModifyPrice(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Modify/Price', val)
  }

  GetRemainingUIPCValueFromTotal(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Remaining/UIPCValue/From/Total', val)
  }

  GetPriceInformation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Price/Information', val)
  }

  GetSingleExchange(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Exchange/Single', val)
  }

  GetCountryTaxations(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Country/Taxations', val)
  }

  AddUpdateCountryTaxation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Country/Taxation', val)
  }

  DeleteCountryTaxation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Country/Taxation', val)
  }

  GetCompanyTaxationSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Company/Taxation/Settings', val)
  }

  AddUpdateCompanyTaxationSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Company/Taxation/Settings', val)
  }

  DeleteCompanyTaxationSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Company/Taxation/Settings', val)
  }

  GetShippingCompanyServiceTypes(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Shipping/Company/Service/Types', val)
  }

  AddUpdateHistoryYearSetting(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/History/Year/Setting', val)
  }

  GetPartnersB2BHistoryYearSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partners/B2B/History/Year/Settings', val)
  }

  GetPartnerFinancialData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/Financial/Data', val)
  }

  GetPartnersFinancialData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partners/Financial/Data', val)
  }

  GeneratePartnersSearchResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Generate/Partners/Search/Results', val)
  }

  DeletePartnersB2BHistoryYearSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Delete/Partners/B2B/History/Year/Settings', val)
  }

  GetPartnerB2BSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/B2B/Settings', val)
  }

  AddUpdatePartnerB2BSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Partner/B2B/Settings', val)
  }

  GetPartnerB2BRestictions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/B2B/Restictions', val)
  }

  DeletePartnerB2BRestriction(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Delete/Partner/B2B/Restriction', val)
  }

  AddUpdatePartnerB2BRestriction(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Partner/B2B/Restriction', val)
  }

  AddNewPartnerFromShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/NewPartner/From/Shipping/Address', val)
  }

  GetPartnerProcessingSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/Processing/Settings', val)
  }

  AddUpdatePartnerProcessingSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Partner/Processing/Settings', val)
  }

  GetPartnerProfitSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/Profit/Settings', val)
  }

  DeleteProfitSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Delete/Profit/Settings', val)
  }

  CheckUserProfitRights(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Check/User/Profit/Rights', val)
  }

  AddUpdatePartnerProfitSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Partner/Profit/Settings', val)
  }

  AddUpdatePartnerPrefferedStockFormat(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Partner/Preffered/Stock/Format', val)
  }

  GetPartnerPrefferedStockFormat(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/Preffered/Stock/Format', val)
  }

  InitializeNewPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Initialize/New/Partner', val)
  }

  AddPartnerAgentsAutomationTaskConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Partner/Agents/Automation/Task/Connection', val)
  }

  DeletePartnerAgentsAutomationTaskConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Delete/Partner/Agents/Automation/Task/Connection', val)
  }

  DeletePartnerAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Delete/Partner/Agent', val)
  }

  GetPartnerAgents(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/Agents', val)
  }

  DeletePartnerShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Delete/Partner/Shipping/Address', val)
  }

  InitializePartnerAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Initialize/Partner/Agent', val)
  }

  AddUpdatePartnerAgent(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Partner/Agent', val)
  }

  GetWarehouse(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Warehouse', val)
  }

  GetPartnerShippingAddresses(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner/Shipping/Addresses', val)
  }

  GetAutomatedTasksConnections(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Automated/Tasks/Connections', val)
  }

  AddUpdateAutomatedTaskConnection(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Automated/Task/Connection', val)
  }

  AddUpdateShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Add/Update/Shipping/Address', val)
  }

  GetPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partner', val)
  }

  GenerateInitialShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Generate/Initial/Shipping/Address', val)
  }

  GetPartnersMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Partners/MasterData', val)
  }

  AddNewPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/addNew', val)
  }

  UpdatePartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Update', val)
  }

  GetPartnersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Filtered', val)
  }

  DeletePartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/DeletePartner', val)
  }

  ValidateVATNumberEU(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/validate/eu/vat', val)
  }

  GetPartnerEUData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/get/eu/data', val)
  }

  GetSetPartnerAgents(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Partners/Get/Set/Partner/Agents', val)
  }

  GetUsersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/get/filtered', val)
  }

  GetUser(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/get/details', val)
  }

  AddUpdateUserSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/update/usersettings', val)
  }

  UpdateUserRights(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/update/user/rights', val)
  }

  GetUserAssignedCompanies(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/user/get/user/assigned/companies', val)
  }

  MatchUnallocatedUIT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Match/Unallocated/UIT', val)
  }

  GetUpcomingReceptionsToBePaidCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Get/Upcoming/Receptions/To/Be/Paid/COUNT', val)
  }

  GetUpcomingReceptionsToBePaid(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Get/Upcoming/Receptions/To/Be/Paid', val)
  }

  ForceReceptionDocumentClosing(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Force/Document/Closing', val)
  }

  GetPreImportedReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Get/Pre/Imported/Reception', val)
  }

  UpdateReceptionsPaymentApprovalStatuses(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Update/Receptions/Payment/Approval/Statuses', val)
  }

  DeleteReceptionShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Delete/Shipping/Details', val)
  }

  UpdateReceptionShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Update/Shipping/Details', val)
  }

  AddReceptionShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Add/Shipping/Details', val)
  }

  ProofReceptionShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Proof/Shipping/Details', val)
  }

  GetReceptionShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Get/Reception/ShippingDetails', val)
  }

  AutoPrintReceptions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Auto/Print/Receptions', val)
  }

  PushConnectedServiceResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Push/Connected/ServiceResults', val)
  }

  DeleteConnectedServiceSuggestedProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Delete/ConnectedService/SuggestedProduct', val)
  }

  AddUpdateConnectedServiceSuggestedStockProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Add/Update/ConnectedService/Suggested/StockProduct', val)
  }

  GetExtraResultProductsFromConnectedService(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Get/Extra/Result/Products/From/ConnectedService', val)
  }

  ConnectedServiceSuggestionProductSelectionChange(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Connected/Service/Suggestion/Product/Selection/Change', val)
  }

  ReinitializeConnectedServiceProductResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Reinitialize/ConnectedService/Product/Results', val)
  }

  SearchReceptionProductsFromConnectedService(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Search/Reception/Products/From/ConnectedService', val)
  }

  RemoveReceptionFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Remove/Reception/File', val)
  }

  DownloadReceptionFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Download/Reception/File', val)
  }

  UploadReceptionFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Upload/Reception/File', val)
  }

  GetTaxDivisionCalculation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/get/taxdivision/calculation', val)
  }

  SearchReceptions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Search/Receptions', val)
  }

  ExportReceptionsValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Export/Receptions/Values', val)
  }

  SearchProductsReceptionInformation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Search/Products/ReceptionInformation', val)
  }

  GetDocumentDupplication(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/get/document/dupplication', val)
  }

  GetReceptionsMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/new/masterData', val)
  }

  AddReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/add/new', val)
  }

  GetReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/get/reception', val)
  }

  GetReceptionTotalValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/get/reception/total/values', val)
  }

  UpdateReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/update/reception', val)
  }

  GetReceptionsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/get/filtered/receptions', val)
  }

  GetReceptionsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/get/filtered/receptions/count', val)
  }

  DeleteReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/delete/document', val)
  }

  ActivateReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/activate/document', val)
  }

  CancelReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/cancel/document', val)
  }

  PrepareStorno(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/prepare/storno', val)
  }

  ExportReception(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/export', val)
  }

  ApplyReceptionDiscount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/apply/discount', val)
  }

  UpdateProductsSearchResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Update/Products/Search/Results', val)
  } 

  MergeProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Merge/Products', val)
  } 

  ImportProductsFromConnectedService(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Import/Products/From/ConnectedService', val)
  } 

  GetProductHistoryEvents(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Get/Product/History/Events', val)
  }

  ProofAllocatesSubordonatesQuantites(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Proof/Allocated/Subordonates/Quantites', val)
  }

  AutoAdjustProductSubordonateQuantities(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Auto/Adjust/Product/Subordonate/Quantities', val)
  }

  GetSubordonateProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Get/Subordonate/Products', val)
  }

  UpdateProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Update/Product', val)
  }

  GetDeleteProductPossibility(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Get/Delete/Product/Possibility', val)
  }

  DeleteProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Delete/Product', val)
  }

  SuggestProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Suggest/Products', val)
  }

  SuggestProductsCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Suggest/Products/Count', val)
  }

  GetProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Products/Get/Products/Filtered', val)
  }

  GetSearchResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Search/get/results', val)
  }

  PrintSearchDocument(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Search/print/result', val)
  }

  GetSearchDocumentUrl(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Search/Get/Document/Url', val)
  }

  UploadPurchaseContractFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/Upload/PurchaseContract/File', val)
  }

  DownloadPurchaseContractFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/Download/PurchaseContract/File', val)
  }

  RemovePurchaseContractFile(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/Remove/PurchaseContract/File', val)
  }

  SearchPurchaseContracts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/Search/PurchaseContracts', val)
  }

  ExportPurchaseContractsValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/Export/PurchaseContracts/Values', val)
  }

  SearchProductsPurchaseContractInformation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/Search/Products/PurchaseContractInformation', val)
  }

  GetDocumentDupplicationPurchaseContracts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/get/document/dupplication', val)
  }

  GetPurchaseContractsMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/new/masterData', val)
  }

  AddPurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/add/new', val)
  }

  GetPurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/get/PurchaseContract', val)
  }

  GetPurchaseContractTotalValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/get/PurchaseContract/total/values', val)
  }

  UpdatePurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/update/PurchaseContract', val)
  }

  GetPurchaseContractsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/get/filtered/PurchaseContracts', val)
  }

  GetPurchaseContractsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/get/filtered/PurchaseContracts/count', val)
  }

  DeletePurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/delete/document', val)
  }

  ActivatePurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/activate/document', val)
  }

  CancelPurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/cancel/document', val)
  }

  PrepareStornoPurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/prepare/storno', val)
  }

  ExportPurchaseContract(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/export', val)
  }

  ApplyPurchaseContractDiscount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseContracts/apply/discount', val)
  }

  GlobalCombinePartners(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Combine/Partners', val)
  }
}
